import React from 'react';

export const SSOLogout = () => {
    return (
        <div className="login-box">
            <div className="login-logo">
                <img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
            </div>
            <div>
                <h3>Session Expired</h3>
                <p>You are no longer logged into Insights.</p>
                <p>Please return to your Single Sign On provider if you need to log back in.</p>
            </div>
        </div>
    );
};

export default SSOLogout;
